import React from 'react';
import { useProfile } from '../contexts/ProfileContext';
import './ProfileSelector.css';

const ProfileSelector: React.FC = () => {
  const { profiles, selectedProfile, setSelectedProfile, loading } = useProfile();

  if (loading) {
    return <div className="profile-selector-loading">...</div>;
  }

  if (profiles.length === 0) {
    return null;
  }

  return (
    <div className="profile-selector">
      <label htmlFor="profile-select">Viewing Data for:</label>
      <select
        id="profile-select"
        value={selectedProfile?.id || ''}
        onChange={(e) => {
          const profile = profiles.find(p => p.id === e.target.value);
          setSelectedProfile(profile || null);
        }}
      >
        {profiles.map(profile => (
          <option key={profile.id} value={profile.id}>
            {profile.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProfileSelector;
